"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ra_fetch_1 = require("ra-fetch");
var react_1 = require("react");
function useAnalytics(defaultParams, dates, video) {
    if (!defaultParams.from) {
        delete defaultParams.from;
    }
    if (!defaultParams.till) {
        delete defaultParams.till;
    }
    if (defaultParams.from && defaultParams.till) {
        delete defaultParams.days;
    }
    var _a = ra_fetch_1.useApi('backend')
        .index('analytics', defaultParams), analytics = _a[0], setAnalytics = _a[1], params = _a[2], setParams = _a[3];
    react_1.useEffect(function () {
        if (analytics.loading) {
            return;
        }
        if (!analytics.meta.search || !dates || !dates.from) {
            return;
        }
        if (dates.from === analytics.meta.search.from &&
            dates.till === analytics.meta.search.till) {
            return;
        }
        if (dates.from && !dates.till ||
            dates.till && !dates.from) {
            return;
        }
        if (!dates.from && !dates.to) {
            return setParams(defaultParams);
        }
        if (dates.from > dates.till) {
            return;
        }
        var newParams = __assign(__assign({}, params), dates);
        delete newParams.days;
        setParams(newParams);
    }, [dates]);
    if (video) {
        react_1.useEffect(function () {
            if (analytics.loading || params.video_id === video.id) {
                return;
            }
            var newParams = __assign({}, params);
            delete newParams.video_id;
            if (video.id) {
                newParams.video_id = video.id;
            }
            setParams(newParams);
        }, [video.id]);
    }
    return analytics;
}
exports.default = useAnalytics;
